import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import styles from './form-accordion.module.scss';
import {AccordionDetail, AccordionGroup} from './types';
import TSwitch from '../switch';
import {useFormikContext} from 'formik';
import { SVGS } from '../../../../assets/images';
import { useIntl } from 'react-intl';
import { Lx } from '../../../../i18n/consts';

export interface TAccordionProps {
    name: string,
    groups: AccordionGroup[],
    elementType: string,
    optional?: boolean
}
export default function FormAccordion(props: TAccordionProps) {
    const {elementType, name} = props;
    const [groups, change] = React.useState<AccordionGroup[]>(props.groups);
    const {setFieldValue} = useFormikContext();
    const intl = useIntl();

    const handleChange =
        (value: boolean, item: AccordionDetail) => {
            item.selected = value;
            const selectedValues:number[] = [];
            groups.forEach((group, index) => group.subItems.forEach(detail => {
                if(detail.selected){
                    selectedValues.push(detail.id)
                }
            }));
            setFieldValue(name, selectedValues, false)
            change(prevState => [... prevState])
        };
    
    return (
        <div className={styles.accordionContainer}>
            {
                (groups.map((group, index) => (
                    <Accordion key={`accordion_${index}`} className={styles.accordion}>
                        <AccordionSummary key={`accordion_summary_${index}`}
                            expandIcon={<SVGS.KeyboardArrowRightIcon />}
                            aria-controls='timinator-accordion-content'
                            className={styles.accordionSummary}
                            id={`timinator-accordion_${index}`}
                            sx={{
                                minHeight: 'auto',
                                '&.Mui-expanded': {
                                    minHeight: 'auto',
                                },
                                padding: 0,
                                '& .MuiAccordionSummary-content.Mui-expanded': {
                                    margin: '12px 0px 16px 0px',
                                },
                                '& .MuiAccordionSummary-expandIconWrapper svg path': {
                                    fill: 'var(--icons-primary)',
                                },
                            }}>
                            <Typography className={styles.typography}>
                                <span className={styles.name}>{group.name}</span>
                                {(props.optional ?? true) && <span className={styles.optional}>{intl.formatMessage({id: Lx.General.OPTIONAL})}</span>}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={styles.accordionDetails}>
                            {(() => {
                                switch(elementType) {
                                    case 'Switch':
                                        return (group.subItems.map((subItem, subIndex)=> (
                                            <TSwitch key={`tswitch_${index}_${subIndex}`}
                                                checked={subItem.selected}
                                                onChange={value => handleChange(value,subItem)}
                                                label={subItem.name}
                                                name={subItem.name}/>
                                        )))
                                    default:
                                        return (<div>{intl.formatMessage({id: Lx.General.NOT_SUPPORTED})}</div>)
                                }
                            })()}
                        </AccordionDetails>
                    </Accordion>)))
            }
        </div>
    );
}
